import { useEffect } from "react";

// Lightweight social meta updater — no dependencies.
// Updates document.title + OG + Twitter cards for a page. Restores on unmount.
export default function useSocialMeta({ title, description, image, url }) {
  useEffect(() => {
    if (!title && !description && !image) return;
    const prev = { title: document.title, tags: [] };

    if (title) document.title = title;

    const upsert = (attr, value, content) => {
      let el = document.head.querySelector(`meta[${attr}="${value}"]`);
      const created = !el;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, value);
        document.head.appendChild(el);
      }
      prev.tags.push({ el, created, content: el.getAttribute("content") });
      el.setAttribute("content", content);
    };

    const pageUrl = url || (typeof window !== "undefined" ? window.location.href : "");

    if (description) upsert("name", "description", description);
    if (title) upsert("property", "og:title", title);
    if (description) upsert("property", "og:description", description);
    if (image) upsert("property", "og:image", image);
    if (pageUrl) upsert("property", "og:url", pageUrl);
    upsert("property", "og:type", "website");
    upsert("name", "twitter:card", image ? "summary_large_image" : "summary");
    if (title) upsert("name", "twitter:title", title);
    if (description) upsert("name", "twitter:description", description);
    if (image) upsert("name", "twitter:image", image);

    return () => {
      document.title = prev.title;
      prev.tags.forEach(({ el, created, content }) => {
        if (created) el.remove();
        else if (content !== null) el.setAttribute("content", content);
      });
    };
  }, [title, description, image, url]);
}
